<template>
  <div class="component-sign" v-show="visible">
    <SignCanvas ref="signRef" v-model="sign" :options="options" />
    <div class="component-sign-action">
      <div class="sign-tip">请在上方空白处，用正楷体横向书写您的名字</div>
      <div class="component-sign-btn btn-light" @click="$emit('update:visible', false)">取消</div>
      <div class="component-sign-btn btn-light" @click="handleClearCanvas">重签</div>
      <div :class="sign ? '' : 'disable'" class="component-sign-btn btn-primary" @click="handleSubmit">提交签字</div>
    </div>
  </div>
</template>

<script>
import SignCanvas from 'sign-canvas'

export default {
  name: 'Sign',
  components: { SignCanvas },
  props: {
    /**
     * 是否可见
     */
    visible: {
      type: Boolean,
      default: true
    }
  },
  data() {
    // 屏幕宽度和高度
    const windowWidth = document.documentElement.clientWidth || document.body.clientWidth
    const windowHeight = document.documentElement.clientHeight || document.body.clientHeight
    return {
      sign: '',
      options: {
        // 书写速度 [Number] 可选
        lastWriteSpeed: 1,
        // 下笔的宽度 [Number] 可选
        lastWriteWidth: 4,
        // 线条的边缘类型 [butt]平直的边缘 [round]圆形线帽 [square]    正方形线帽
        lineCap: 'round',
        // 线条交汇时边角的类型  [bevel]创建斜角 [round]创建圆角 [miter]创建尖角。
        lineJoin: 'round',
        // canvas宽高 [Number] 可选
        canvasWidth: windowWidth,
        // 高度  [Number] 可选
        canvasHeight: windowHeight,
        // 是否显示边框 [可选]
        isShowBorder: false,
        // 背景色 [String] 可选
        bgColor: '#FFFFFF',
        // 网格线宽度  [Number] 可选
        // borderWidth: 1,
        // 网格颜色  [String] 可选
        // borderColor: "#ff787f",
        // 基础轨迹宽度  [Number] 可选
        writeWidth: 5,
        // 写字模式最大线宽  [Number] 可选
        maxWriteWidth: 30,
        // 写字模式最小线宽  [Number] 可选
        minWriteWidth: 5,
        // 轨迹颜色  [String] 可选
        writeColor: '#101010',
        // 签名模式 [Boolean] 默认为非签名模式,有线框, 当设置为true的时候没有任何线框
        isSign: true,
        // 下载的图片格式  [String] 可选为 jpeg  canvas本是透明背景的
        imgType: 'png'
      }
    }
  },

  methods: {
    /**
     * 清空画布
     */
    handleClearCanvas() {
      this.$refs.signRef.canvasClear()
    },

    /**
     * 提交方法
     */
    async handleSubmit() {
      // 如果当前没有签名
      if (!this.sign) {
        return
      }
      // 当前签名
      const canvas = document.createElement('canvas')
      const context = canvas.getContext('2d')
      const img = new Image()
      img.src = this.sign
      img.onload = () => {
        canvas.width = img.height
        canvas.height = img.width
        context.translate(canvas.width / 2, canvas.height / 2)
        context.rotate(-90 * Math.PI / 180)
        context.translate(canvas.width / 4, -canvas.height / 2)
        context.drawImage(img, -canvas.width / 2, -canvas.height / 2, img.width, img.height)
        // 将当前生成的签名图片返回
        this.$emit('submit', canvas.toDataURL('image/png'))
        // 关闭弹框
        this.$emit('update:visible', false)
        // 清空画板
        this.handleClearCanvas()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.component-sign {
  background-color: #ffffff;
  bottom: 0;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9;
  .component-sign-action {
    align-items: center;
    border-top: 1px solid #DCDFE6;
    bottom: 0;
    display: flex;
    left: 0;
    top: -154px;
    width: 100vh;
    height: 154px;
    position: fixed;
    transform: rotate(90deg);
    transform-origin: left bottom;
    justify-content: center;
    .sign-tip {
      color: #242424;
      font-size: 28px;
      font-weight: 400;
      opacity: 0.4;
      margin-right: 70px;
    }
    .component-sign-btn {
      align-items: center;
      border-radius: 48px;
      display: flex;
      font-size: 30px;
      font-weight: 500;
      width: 254px;
      height: 96px;
      justify-content: center;
      margin-left: 24px;
      &.btn-light {
        background-image: linear-gradient(120deg, #FFF 0%, #FFF 97%);
        color: #242424;
        border: 1px solid;
        height: 80px;
        font-size: 26px;
      }
      &.btn-primary {
        background-image: linear-gradient(120deg, #000 0%, #000 97%);
        color: #ffffff;
        height: 80px;
        font-size: 26px;
      }
      &.disable {
        opacity: 0.5;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Sign/index.vue